import styled from 'styled-components';

export const InputCompleted = styled.input`
  .completed-check {
    height: '1.3em';
    width: '1.3em';
  }
`;

export const DeleteButton = styled.a`
  .delete-task-link:hover {
    color: ${(props) => props.theme.$red} !important;
    border-color: #fff;
  }
`;

export const ContainerAudioPreview = styled.div`
  border: 1px solid ${(props) => props.theme.$gray400};
  border-radius: 0.25rem;
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;

  .audio-equalizer-bars,
  .audio-cancel,
  .audio-submit {
    background: transparent;
    color: ${(props) => props.theme.$gray600};
    border-radius: 0px;
    padding: 2px;
    &:disabled {
      cursor: default;
    }
    &:hover {
      background: ${(props) => props.theme.$gray300};
      padding: 2px;
      border-radius: 4px;
    }
  }
`;
